/* eslint-env browser */

window.scrollTo(0, 0)
const menu = document.querySelector('.menu')

let offsetValue
const getMenuRect = () => {
  fastdom.measure(() => {
    offsetValue = menu.getBoundingClientRect().height
  })
}

const smoothScroll = new SmoothScroll('a[href*="#"]:not([href="#"])', { // eslint-disable-line no-undef, no-unused-vars
  speed: 1000,
  offset() {
    return `${offsetValue}px`
  },
  easing: 'easeInOutCubic',
})

if (menu) {
  getMenuRect()
  window.addEventListener('resize', getMenuRect, false)
}
